<div class="size-full">
  <palantir-progress-bar
    *ngIf="loadingService.isLoading | async"
    class="fixed top-0 z-[999999] self-stretch"
    mode="indeterminate"
    style="width: 100%"
  ></palantir-progress-bar>

  <router-outlet />
</div>
